module.exports = "https://cdn.realtymogul.com/static/media/icon_off_market.19fec0ba.svg";